import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import _ from 'lodash'

class NRTFormInput extends Component {

    static SHOW_ERROR_MSGS_DELAY = 1000

    state = {
        initialValue: this.props.value || null,
        value: this.props.value || undefined,
        errorMessages: [],
        showErrorMessages: false,
    }


    static getDerivedStateFromProps(nextProps) {
        return {
            disabled: nextProps.disabled
        }
    }


    componentDidMount() {
        this.props.notifyStateManager(this.state.value)
    }


    handleChange = async (value) => {
        if (this.state.disabled)
            return

        const errorMessages = await this.getErrorMessages(value)
        const hasError = errorMessages.length !== 0

        this.setState({
            value,
            dirty: true,
            errorMessages: [],
            showErrorMessages: false,
        }, async () => {
            if (!!this.props.onChange)
                this.props.onChange(value)

            this.notifyStateManager(value, true, !hasError)
            setTimeout(this.showErrorMessages, NRTFormInput.SHOW_ERROR_MSGS_DELAY)

            if (hasError)
                this.setState({errorMessages})

        })

    }


    showErrorMessages = _.debounce(() => this.setState({showErrorMessages: true}), 150)


    reset() {
        const {initialValue} = this.state
        this.setState({
            value: initialValue,
            errorMessages: [],
            dirty: false
        }, () => this.notifyStateManager(initialValue, false, true))
    }


    async validate() {
        const {value, dirty} = this.state
        const errorMessages = await this.getErrorMessages(value)
        const isValid = errorMessages.length === 0

        this.setState({errorMessages})
        this.notifyStateManager(value, dirty, isValid)

        return isValid
    }


    async getErrorMessages(value) {
        const errorMessages = await Promise.all(this.props.validators.map(validator => validator(value)))
        return errorMessages.filter(msg => msg !== null)
    }


    onLabelClick = () => {
        //this.input.focus()
    }


    notifyStateManager(value, dirty, valid) {
        if (!!this.props.notifyStateManager)
            this.props.notifyStateManager(value, dirty, valid)
    }


    render() {
        const {
            name,
            label,
            customClass = '',
            style,
            inputEl: Input,
            inputProps,
            labelStyle,
        } = this.props

        const {
            value,
            errorMessages,
            showErrorMessages,
        } = this.state


        const errorCls = showErrorMessages && errorMessages.length > 0 ? ' error ' : ' '


        // console.log('render forminput ')
        return (
            <div className={customClass + errorCls + ' nrt-form-input-2'}
                 style={{...style}}>
                {
                    label &&
                    <label style={labelStyle}
                           htmlFor={name}
                           onClick={this.onLabelClick}>
                        {label}
                    </label>
                }

                <Input
                    value={value}
                    onChange={this.handleChange}
                    {...inputProps}
                />


                {
                    showErrorMessages &&
                    errorMessages.length > 0 &&
                    <div className={'error-msgs'}>
                        {
                            errorMessages
                                .map((msg, index) => (
                                    <span key={`${name}-error-${index}`} className={errorCls}>{msg}</span>
                                ))
                        }
                    </div>
                }


            </div>
        )
    }
}


NRTFormInput.propTypes = {
    notifyStateManager: PropTypes.func,
    inputEl: PropTypes.func.isRequired,
    inputProps: PropTypes.object,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    label: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    customClass: PropTypes.string,
    style: PropTypes.object,
    labelStyle: PropTypes.object,
    validators: PropTypes.array,
}

NRTFormInput.defaultProps = {
    inputProps: {},
    disabled: false,
    onChange: () => null,
    customClass: ' ',
    style: {},
    labelStyle: {},
    validators: [],
}

export default NRTFormInput



// WEBPACK FOOTER //
// ./src/components/_common/FormStateManager/FormInput/index.js